var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.6667C17 14.8986 17.7024 13.2029 18.9526 11.9526C20.2029 10.7024 21.8986 10 23.6667 10H39.5C39.721 10 39.933 10.0878 40.0893 10.2441C40.2455 10.4004 40.3333 10.6123 40.3333 10.8333V26.6667C40.3333 28.4348 41.0357 30.1305 42.286 31.3807C43.5362 32.631 45.2319 33.3333 47 33.3333H62.8333C63.0543 33.3333 63.2663 33.4211 63.4226 33.5774C63.5789 33.7337 63.6667 33.9457 63.6667 34.1667V63.3333C63.6667 65.1014 62.9643 66.7971 61.714 68.0474C60.4638 69.2976 58.7681 70 57 70H23.6667C21.8986 70 20.2029 69.2976 18.9526 68.0474C17.7024 66.7971 17 65.1014 17 63.3333V16.6667Z",
    fill: "#E6F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.332 26.6669V12.0135C43.3317 11.8485 43.3805 11.6871 43.472 11.5498C43.5635 11.4125 43.6938 11.3054 43.8463 11.2422C43.9987 11.179 44.1665 11.1625 44.3284 11.1948C44.4902 11.2271 44.6388 11.3067 44.7554 11.4235L61.9087 28.5769C62.0255 28.6934 62.1052 28.842 62.1374 29.0039C62.1697 29.1657 62.1532 29.3335 62.09 29.486C62.0268 29.6384 61.9198 29.7687 61.7825 29.8602C61.6451 29.9518 61.4837 30.0005 61.3187 30.0002H46.6654C45.7813 30.0002 44.9335 29.649 44.3083 29.0239C43.6832 28.3988 43.332 27.5509 43.332 26.6669Z",
    fill: "#139CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4727 57H28.7031V48.5449H34.2402V50.0039H30.4727V52.2715H33.9121V53.6719H30.4727V57ZM37.0586 57H35.2891V48.5449H37.0586V57ZM43.9316 55.5352V57H38.4648V48.5449H40.2344V55.5352H43.9316ZM50.582 55.5352V57H44.9805V48.5449H50.582V50.0039H46.75V52.043H50.3652V53.4023H46.75V55.5352H50.582Z",
    fill: "#139CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLogo);
export default __webpack_public_path__ + "static/media/file-logo.b590380b676e6af1a57e4a2b6992a9cd.svg";
export { ForwardRef as ReactComponent };